import { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { authApi } from '@/auth/api';
import { useAuthStore } from '@/auth/store';

export function LoginPage() {
  const status = useAuthStore((s) => s.status);
  const [pending, setPending] = useState(false);
  const [error, setError] = useState<string | null>(null);

  if (status === 'authenticated') {
    return <Navigate to="/" replace />;
  }

  async function handleConnect() {
    setError(null);
    setPending(true);
    try {
      const { auth_url } = await authApi.startLichessOAuth();
      window.location.assign(auth_url);
    } catch (e) {
      setPending(false);
      setError('Impossible de lancer la connexion. Réessaye dans 2 s.');
      console.error(e);
    }
  }

  return (
    <main className="mx-auto flex min-h-screen max-w-2xl flex-col items-center justify-center gap-10 px-6">
      <header className="flex flex-col items-center gap-3">
        <img
          src="/logo-vertical.png"
          alt="The Chess Coach"
          width={205}
          height={256}
          className="h-64 w-auto object-contain"
        />
        <p className="text-body text-ink-300">Ta zone de déploiement.</p>
      </header>

      <section className="flex w-full flex-col gap-4 rounded-xl border border-ink-700 bg-ink-800 p-8">
        <p className="text-caption uppercase text-ink-300">Authentification</p>
        <p className="text-body text-paper-50">
          Connecte-toi avec ton compte Lichess pour accéder à ta console.
        </p>
        <button
          type="button"
          onClick={handleConnect}
          disabled={pending}
          className="rounded-lg bg-acid-500 px-6 py-3 font-display text-heading-3 text-ink-900 transition hover:opacity-90 disabled:opacity-50"
        >
          {pending ? 'Redirection…' : 'Connexion Lichess'}
        </button>
        {error && <p className="text-body-sm text-coral-500">{error}</p>}
      </section>

      <footer className="text-caption uppercase text-ink-300">
        Connexion sécurisée Lichess — aucun mot de passe stocké.
      </footer>
    </main>
  );
}
